import { User } from 'src/api/model/user';
import { RequestBuilder } from 'src/api/common/request-builder';
// import { UserModule } from '@/store/modules/user'
import { UserSearchForm } from 'src/api/model/search/user-search-form';
import { Pagable } from 'src/constants/pagable';
import { RequestUtils } from 'src/utils/request-utils';
import { UserForm } from 'src/api/model/form/user-form';
import { UserData } from 'src/api/model/response/user-data';
import { UserRoleForm } from '../model/form/user-role-form';
import { Page } from '../common/page';

export class UserApi {
  findAll(
    form: UserSearchForm,
    pagable: Pagable,
  ): Promise<User[]> {
    pagable.size = 10;
    pagable.page = 0;
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<User>()
      .url('/member/user')
      .config({ params: params })
      .findAll();
  }

  findAllAdmin(
    form: UserSearchForm,
    pagable: Pagable,
  ): Promise<User[]> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<User>()
      .url('/member/user/findAllAdmin')
      .config({ params: params })
      .findAll();
  }

  findAllMember(
    form: UserSearchForm,
    pagable: Pagable,
  ): Promise<Page<User>> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<User>()
      .url('/member/user/findAllMember')
      .config({ params: params })
      .findAllPagging();
  }

  findById(id: string): Promise<User> {
    return new RequestBuilder<User>()
      .url(`/member/user/${id}`)
      .findOne();
  }

  findByUsername(username: string): Promise<User> {
    return new RequestBuilder<User>()
        .url(`/member/user/findByUsername?username=${username}`)
        .findOne();
  }

  // loadUserDeptRoles(form: UserDeptRole, pagable: Pagable): Promise<UserDeptRole[]> {
  //   const params = RequestUtils.merge(
  //     form,
  //     RequestUtils.initPageableParams(pagable)
  //   )
  //   return new RequestBuilder<UserDeptRole>()
  //     .url('/userDeptRoleView')
  //     .config({ params: params })
  //     .findAll()
  // }

  saveNotificationToken(data: any) {
    return new RequestBuilder<User>()
      .url('/member/user/activity')
      .data(data)
      .post();
  }

  save(form: UserForm) {
    return new RequestBuilder<User>()
      .url('/member/user')
      .data(form)
      .post();
  }

  update(id: string, form: UserForm) {
    return new RequestBuilder<User>()
      .url(`/member/user/${id}`)
      .data(form)
      .put();
  }

  updateRole(id: string, form: UserRoleForm) {
    return new RequestBuilder<User>()
      .url(`/member/user/role/${id}`)
      .data(form)
      .post();
  }

  deleteNotificationToken(data: any) {
    return new RequestBuilder<void>()
      .url(`/member/user/activity`)
      .data(data)
      .delete();
  }

  delete(id: string) {
    return new RequestBuilder<User>()
      .url(`/member/user/${id}`)
      .delete();
  }
  //
  // findAllRole(form: RoleSearchForm, pagable: Pagable): Promise<Role[]> {
  //   const params = RequestUtils.merge(
  //     form,
  //     RequestUtils.initPageableParams(pagable)
  //   )
  //   return new RequestBuilder<Role>()
  //     .url('/role')
  //     .config(params)
  //     .findAll()
  // }

  getUserDeptByRole(): Promise<UserData[]> {
    return new RequestBuilder<UserData>()
      .url(`/member/user/getUserDeptByRole`)
      .findAll();
  }

  getUsers(): Promise<UserData[]> {
    return new RequestBuilder<UserData>()
      .url(`/member/user/allData`)
      .findAll();
  }
  
  getUsersAllStatus(): Promise<UserData[]> {
    return new RequestBuilder<UserData>()
    .url(`/member/user/find-all-user`)
    .findAll();
  }

  getUsersInDept(id: string): Promise<UserData[]> {
    return new RequestBuilder<UserData>()
      .url(`/member/user/allDataInDept/${id}`)
      .findAll();
  }

  getUsersInDeptIds(ids: string[]): Promise<string[]> {
    return new RequestBuilder<string>()
      .url(`/member/user/getUsersInDeptIds/`)
      .config({ params: { ids: ids } })
      .findAll();
  }

  getUsersInDepts(ids: string[]): Promise<UserData[]> {
    return new RequestBuilder<UserData>()
        .url(`/member/user/allDataInDepts`)
        .config({ params: { ids: ids } })
        .findAll();
  }


  getDepts(id: string): Promise<string[]> {
    return new RequestBuilder<string>()
      .url(`/member/user/getDepts`)
      .config({ params: { userId: id } })
      .findAll();
  }
}

export const userApi = new UserApi();